import * as React from "react";

function SvgGit(props) {
  return (
    <svg
      viewBox="0 0 1000 1000"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <path d="M1000 0H0v1000h1000V0zM397.093 889.453c0 14.01 256.497 14.115 256.497 0 0-17.47.6-74.588.6-145.557 0-49.486-16.533-81.765-35.088-98.225 115.193-13.131 236.212-57.979 236.212-261.709 0-57.899-20.071-105.224-53.241-142.369 5.372-13.359 23.087-67.307-5.071-140.367 0 0-43.381-14.246-142.118 54.378-41.342-11.752-85.631-17.646-129.594-17.857-43.963.211-88.217 6.105-129.482 17.857-98.857-68.624-142.298-54.378-142.298-54.378-28.09 73.06-10.383 127.008-5.011 140.367-33.093 37.145-53.301 84.47-53.301 142.369 0 203.239 120.787 248.728 235.69 262.131-14.795 13.245-28.201 36.653-32.844 70.926-29.52 13.552-104.4 36.995-150.539-44.084 0 0-27.353-50.926-79.3-54.668 0 0-50.474-.676-3.538 32.244 0 0 33.906 16.311 57.438 77.61 0 0 30.368 94.667 174.285 62.581.223 44.321.703 86.103.703 98.751z" />
    </svg>
  );
}

export default SvgGit;